import styles from './Table.module.css';

interface TableProps {
	children: React.ReactNode;
	className?: string;
}

interface TableHeaderProps {
	columns: Array<{ key: string; label: string; mono?: boolean; width?: string }>;
}

interface TableRowProps {
	children: React.ReactNode;
	onClick?: () => void;
}

interface TableCellProps {
	mono?: boolean;
	children: React.ReactNode;
	colSpan?: number;
}

function TableRoot({ children, className }: TableProps) {
	return (
		<div className={[styles.tableWrapper, className].filter(Boolean).join(' ')}>
			<table className={styles.table}>{children}</table>
		</div>
	);
}

function TableHeader({ columns }: TableHeaderProps) {
	return (
		<thead>
			<tr>
				{columns.map((col) => (
					<th
						key={col.key}
						className={[styles.th, col.mono ? styles.mono : ''].filter(Boolean).join(' ')}
						style={col.width ? { width: col.width } : undefined}
					>
						{col.label}
					</th>
				))}
			</tr>
		</thead>
	);
}

function TableBody({ children }: { children: React.ReactNode }) {
	return <tbody>{children}</tbody>;
}

function TableRow({ children, onClick }: TableRowProps) {
	return (
		<tr
			className={[styles.row, onClick ? styles.rowClickable : ''].filter(Boolean).join(' ')}
			onClick={onClick}
		>
			{children}
		</tr>
	);
}

function TableCell({ mono = false, children, colSpan }: TableCellProps) {
	return (
		<td
			className={[styles.td, mono ? styles.mono : ''].filter(Boolean).join(' ')}
			colSpan={colSpan}
		>
			{children}
		</td>
	);
}

export const Table = Object.assign(TableRoot, {
	Header: TableHeader,
	Body: TableBody,
	Row: TableRow,
	Cell: TableCell,
});
